export enum AuthReduxActions {
  SET_AUTH_DATA = "SET_AUTH_DATA",
  LOGOUT = "LOGOUT",
  RESET_STORE = "RESET_STORE",
}

const setAuthData = (payload: any): any => ({
  type: AuthReduxActions.SET_AUTH_DATA,
  payload,
});

const doLogout = (payload) => ({
  type: AuthReduxActions.LOGOUT,
  payload,
});

const resetStore = (payload) => ({
  type: AuthReduxActions.RESET_STORE,
  payload,
});

export const AuthActions = {
  setAuthData,
  doLogout,
  resetStore,
};
